import { useEffect, useState } from "react";

export type ChatWidth = "standard" | "wide";
const DEFAULT_CHAT_WIDTH: ChatWidth = "standard";
const STORAGE_KEY = "chatWidth";

export function useChatWidthState() {
  const [chatWidthState, setChatWidthState] = useState<ChatWidth>(
    (localStorage.getItem(STORAGE_KEY) as ChatWidth) ?? DEFAULT_CHAT_WIDTH
  );

  function setChatWidth(newChatWidth: ChatWidth) {
    localStorage.setItem(STORAGE_KEY, newChatWidth);
    setChatWidthState(newChatWidth);
  }

  const rootClassList = document.documentElement.classList;

  useEffect(() => {
    rootClassList.remove("chat-width--wide");
    if (chatWidthState === "wide") {
      rootClassList.add("chat-width--wide");
    }
  }, [chatWidthState, rootClassList]);

  return [chatWidthState, setChatWidth] as const;
}
